import MeaDetailCard from "../../../../components/MeaDetailCard";

const MemberDetailAvatarComponent = ({ member, canEditAvatar, onEditAvatar }) => {
  const imageSrc = member?.avatar
    ? member?.avatar + "?u=" + member?.updated_at
    : "/user.png";

  const handleKeyDown = (event) => {
    if (!canEditAvatar || !onEditAvatar) {
      return;
    }
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onEditAvatar();
    }
  };

  return (
    <MeaDetailCard>
      <div
        role={canEditAvatar ? "button" : undefined}
        tabIndex={canEditAvatar ? 0 : undefined}
        onClick={canEditAvatar ? onEditAvatar : undefined}
        onKeyDown={handleKeyDown}
        style={{
          cursor: canEditAvatar ? "pointer" : "default",
          outline: "none",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%"
        }}
        aria-label={canEditAvatar ? "Modifier la photo du membre" : "Photo du membre"}
      >
        <img
          src={imageSrc}
          alt="Image"
          style={{
            borderRadius: "50%",
            width: "120px",
            height: "120px",
            objectFit: "cover",
            display: "block"
          }}
        />
      </div>
    </MeaDetailCard>
  );
};

export default MemberDetailAvatarComponent;
